import React from 'react';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';

export const ContactSection = () => (
  <section id="contact" className="py-24 bg-[#8B7355] text-white">
    <div className="max-w-4xl mx-auto px-6">
      <div className="text-center mb-12">
        <h2 className="text-5xl md:text-6xl font-serif mb-6 italic">Let's Create Magic</h2>
        <p className="text-xl opacity-90">
          Ready to elevate your event? Get in touch for a custom quote.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <Card className="bg-white/10 backdrop-blur-sm border-none text-white">
          <CardContent className="p-8">
            <Mail className="w-10 h-10 text-[#C9A961] mb-4" />
            <h3 className="text-xl font-serif mb-2">Email Us</h3>
            <a href="mailto:shot2thenines@gmail.com" className="hover:text-[#C9A961] transition-colors">
              shot2thenines@gmail.com
            </a>
          </CardContent>
        </Card>

        <Card className="bg-white/10 backdrop-blur-sm border-none text-white">
          <CardContent className="p-8">
            <Phone className="w-10 h-10 text-[#C9A961] mb-4" />
            <h3 className="text-xl font-serif mb-2">Call Us</h3>
            <a href="tel:0411803940" className="hover:text-[#C9A961] transition-colors">
              0411 803 940
            </a>
          </CardContent>
        </Card>

        <Card className="bg-white/10 backdrop-blur-sm border-none text-white">
          <CardContent className="p-8">
            <Globe className="w-10 h-10 text-[#C9A961] mb-4" />
            <h3 className="text-xl font-serif mb-2">Visit Online</h3>
            <a href="https://shottothenines.com.au" target="_blank" rel="noopener noreferrer" className="hover:text-[#C9A961] transition-colors">
              shottothenines.com.au
            </a>
          </CardContent>
        </Card>

        <Card className="bg-white/10 backdrop-blur-sm border-none text-white">
          <CardContent className="p-8">
            <MapPin className="w-10 h-10 text-[#C9A961] mb-4" />
            <h3 className="text-xl font-serif mb-2">Service Areas</h3>
            <p>Brisbane & Gold Coast</p>
          </CardContent>
        </Card>
      </div>

      <div className="text-center">
        <p className="text-lg mb-6 opacity-90">Perfect for:</p>
        <div className="flex flex-wrap justify-center gap-4">
          {['Weddings', 'Parties', 'Corporate Events', 'Celebrations'].map((tag) => (
            <Badge key={tag} className="bg-white/20 text-white border-none px-4 py-2 text-base font-serif">
              {tag}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  </section>
);
